import { EntityId } from '@reduxjs/toolkit';
import React, { Dispatch, SetStateAction } from 'react';
import { TEvent } from '../events';
import { EStatus, TBottomSheetsWidgetsMap } from '../store';
import { TCommonData } from './data';
import { ActionActionTypeEnum, ActionPlayerTypeNameEnums, ActionSystemActionType, ActionTypeEnum } from './enums';
import { TWidgetCommonOption } from './options';

export type TActionData = Record<TWidget<TCommonData>['uid'], unknown>;
export type TWInternalId = string | null;

export type TWAction = {
    name: string | ActionPlayerTypeNameEnums;
    page: EntityId;
    actionType: string | ActionActionTypeEnum;
    type?: ActionTypeEnum;
    delay?: number;
    /*
     * this is only for orchestrator!!!
     */
    widgetId: TWInternalId;
    data?: TActionData;
    clearSession?: boolean;
    systemActionType?: Array<ActionSystemActionType>;
};

export type TPayloadWidget<TD, TO = TWidgetCommonOption> = { widgets: Array<TPayloadWidget<TD, TO>> } & TWidget<TD, TO>;

/**
 * Type describe the additional data for widget
 *
 * @property {lastValueUpdateAction} string - the name of last Redux action witch change the widget value
 */
export type TWidgetSystemMetadata = {
    lastValueUpdateAction?: string;
};

export type TWidget<TD, TO = TWidgetCommonOption> = {
    uid: string;
    id: string;
    alternativeId: string;
    internalId?: TWInternalId;
    widgets: Array<TWidget<TD>['uid']>;
    data: TD;
    options: TO;
    isValid?: boolean;
    templateId?: string;
    actions?: TWAction[];
    functions?: Record<TEvent['type'], string>;
    systemMetadata: TWidgetSystemMetadata;
    /**
     * Version of the widget implementation: it may change the widget's design, its behavior, or both. Each widget
     * reads its own version, so one page may mix versions. Missing or unknown means the original version (1).
     */
    version?: number;
};

export interface IWidgetsListProps {
    uids?: Array<string>;
    widgets?: Array<TWidget<TCommonData>>;
}

export type TBottomSheetProps = {
    widgetId?: string;
    modal: React.ReactNode | null;
    WidgetsList: React.FC<IWidgetsListProps>;
    setBottomSheet: Dispatch<SetStateAction<string | undefined>>;
    bottomSheets: TBottomSheetsWidgetsMap;
    status?: EStatus;
    isWidgetLoading?: boolean;
};

export type TModalWindowProps = {
    widgetId?: string;
    WidgetsList: React.FC<IWidgetsListProps>;
    setModalWindow: Dispatch<SetStateAction<string | undefined>>;
    modalWindows: TBottomSheetsWidgetsMap;
    status?: EStatus;
    isWidgetLoading?: boolean;
};
export type TPopupProps = {
    content?: React.ReactNode;
    modal: React.ReactNode | null;
    setPopup: Dispatch<SetStateAction<React.ReactNode>>;
};
